export const selectMapKey = ({ MainReducer }) => {
    return MainReducer.profile.map_api_key;
};
